"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onPresenceChangedHandlerForHost = onPresenceChangedHandlerForHost;
exports.onPresenceChangedHandlerForSpeaker = onPresenceChangedHandlerForSpeaker;
var _logger = require("@studio/logger");
var _constants = require("../../constants");
var _getAttendeePresenceFunc = require("./getAttendeePresenceFunc");
var _subscribeToVolumeIndicator = require("../subscribeToVolumeIndicator");
var _audioVideoHelpers = require("../../audioVideo/audioVideoHelpers");
function onPresenceChangedHandlerForHost(dispatch, actions, meetingSession, meetingResponse) {
  var localAttendeeId = meetingSession.configuration.credentials.attendeeId;
  var meetingId = meetingResponse.Meeting.MeetingId;
  var disconnectSource = actions.disconnectSource,
    setAttendeePresence = actions.setAttendeePresence,
    setAttendeeMuteStatus = actions.setAttendeeMuteStatus,
    setSourceInitializing = actions.setSourceInitializing,
    removePresenter = actions.removePresenter,
    setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity;
  return function onPresenceChanged(attendeeId, present, _, dropped) {
    var setPresence = (0, _getAttendeePresenceFunc.getAttendeePresenceFunc)(dispatch, {
      disconnectSource: disconnectSource,
      setAttendeePresence: setAttendeePresence
    }, attendeeId);
    setPresence(attendeeId, present);
    if (present) {
      (0, _subscribeToVolumeIndicator.subscribeToVolumeIndicator)(dispatch, setAttendeeMuteStatus, meetingSession, attendeeId, setAttendeeVoiceIntensity);
      dispatch(setSourceInitializing(attendeeId, {
        isInitializing: false
      }));
    } else {
      if (attendeeId.includes('content')) {
        dispatch(removePresenter(attendeeId));
        if ("".concat(localAttendeeId, "#content") === attendeeId) {
          (0, _audioVideoHelpers.stopContentShare)(meetingSession);
        }
      }
      meetingSession.audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId);
    }
    var logPayload = {
      chimeEventName: 'onPresenceChanged',
      dropped: dropped,
      'studio.meeting.id': meetingId,
      title: "Attendee id: ".concat(attendeeId, " presence changed to ").concat(present, " in meeting id: ").concat(meetingId)
    };
    (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
  };
}
function onPresenceChangedHandlerForSpeaker(dispatch, actions, meetingSession) {
  var localAttendeeId = meetingSession.configuration.credentials.attendeeId;
  var updateAttendeePresence = actions.updateAttendeePresence,
    setAttendeeVoiceIntensity = actions.setAttendeeVoiceIntensity,
    setAttendeeCameraStatus = actions.setAttendeeCameraStatus;
  return function onPresenceChanged(attendeeId, present) {
    if (present && !!setAttendeeCameraStatus && !attendeeId.includes('#content')) {
      dispatch(setAttendeeCameraStatus(attendeeId, false));
    }
    if (!!setAttendeeVoiceIntensity) {
      if (present) {
        (0, _subscribeToVolumeIndicator.subscribeToVolumeIndicator)(dispatch, null, meetingSession, attendeeId, setAttendeeVoiceIntensity);
      } else {
        meetingSession.audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId);
      }
    }
    if (!present && "".concat(localAttendeeId, "#content") === attendeeId) {
      (0, _audioVideoHelpers.stopContentShare)(meetingSession);
    }
    dispatch(updateAttendeePresence(attendeeId, present));
    var logPayload = {
      chimeEventName: 'onPresenceChanged',
      title: "Attendee id: ".concat(attendeeId, " presence changed to ").concat(present)
    };
    (0, _logger.sendToDatadog)(_constants.loggerName, logPayload, logPayload.title, false);
  };
}